import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { DealerService } from '../services/dealer.service';
import { Dealer } from '../../shared/models/dealer.interface';
import { DealerAccountComponent } from '../../shared/controls/dealer-account/dealer-account.component';
import { DealerAccountData } from '../../shared/models/dealer-account.interface';
import { DealerUsersComponent } from '../dealer-users/dealer-users.component';
import { DatePipe } from '@angular/common';
import { FileService } from '../../shared/services/file.service';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';


@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent extends AbstractBiditComponent implements OnInit {

  dataSource = new MatTableDataSource<Dealer>();
  displayedColumns: string[] =
    ['dealer_BusinessName', 'dealer_City', 'dealer_State', 'dealer_OfficePhone', 'dealer_Email', 'dealer_LastName', 'action'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  dealers: Dealer[];
  
  searchText: string;
  constructor(deviceDetectorService: DeviceDetectorService, private dealerService: DealerService, private fileService: FileService, public dialog: MatDialog) {
    super(deviceDetectorService)
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.searchDealers();
  }

  searchDealers() {
    this.dealerService.searchDealers(this.searchText)
      .subscribe({
        next: (data) => {
          this.dealers = data;

          this.dataSource.data = this.dealers;
        }
      });
  }

  showEdit(dealerId) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = { id: dealerId, isDealerAdmin: false } as DealerAccountData;
    dialogConfig.width = '1100px';
    dialogConfig.maxHeight = '950px';

    const dealerDialogRef = this.dialog.open(DealerAccountComponent, dialogConfig);

    dealerDialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      this.searchDealers();
    });
  }

  showUsers(dealerId) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = { id: dealerId, isDealerAdmin: false } as DealerAccountData;
    dialogConfig.width = '1100px';
    dialogConfig.maxHeight = '950px';

    const dealerUsersDialogRef = this.dialog.open(DealerUsersComponent, dialogConfig);

    dealerUsersDialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  toggleStatus(dealerId) {
    this.dealerService.toggleStatus(dealerId)
      .subscribe(result => {
        console.log(result);
        if (result.dealer_ID > 0) {
          this.dealers.find(d => d.dealer_ID == dealerId).dealer_IsActive = result.dealer_IsActive;
          let activeStatusId = "dealer_status_active" + dealerId;
          let inActiveStatusId = "dealer_status_inactive" + dealerId;

          if (result.dealer_IsActive) {
            document.getElementById(activeStatusId).className = "text-success";
            document.getElementById(inActiveStatusId).className = "";
          }
          else {
            document.getElementById(activeStatusId).className = "";
            document.getElementById(inActiveStatusId).className = "text-danger";
          }
        }
      });
  }

  exportDealers() {
    this.isRequesting = true;

    this.dealerService.exportDealers()
      .subscribe({
        next: (data) => {
          let pipe = new DatePipe('en-US');
          let fileDate = pipe.transform(Date.now(), 'yyyyMMdd HH:mm:ss');
          let filename = `dealerExport_ ${fileDate}.csv`;
          this.fileService.downloadFile(data, filename);
          this.isRequesting = false;
        },
        error: (error: string) => this.onError(error)
      });
  }

}
